import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const ProductArticles = ({ slug }) => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get(`/products/${slug}/articles`).then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, [slug]);
  if (!posts.length) return null;
  return (
    <div data-testid="product-articles" className="mt-6 space-y-2">
      {posts.map((p) => (
        <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`product-article-link-${p.slug}`}
          className="group flex items-center gap-3 rounded-2xl border border-[#E7E0D3] px-4 py-3 hover:bg-[#F0EBE1] transition-colors">
          <BookOpen size={18} className="text-[#4E7B68] shrink-0" />
          <span className="min-w-0 flex-1">
            <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#4E7B68]">Read Kiddee's toy test</span>
            <span className="block font-heading font-semibold truncate">{p.title}</span>
          </span>
          <ArrowRight size={16} className="shrink-0 transition-transform group-hover:translate-x-1" />
        </Link>
      ))}
    </div>
  );
};
